









































import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import {
    getKey,
    Keys,
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    SdsButton,
    SdsButtonIcon,
    SdsIllustration,
} from '@superbet-group/web.lib.ui-components';
import { RouteName } from '@app/router/constants/RouteName';
import { useLoginBeforeNavigate } from '@app/router/composables/useLoginBeforeNavigate';
import { Route } from 'vue-router';
import { useClickOutside } from '@src/app/utils/useClickOutside';
import { PopoversStore } from '@store/modules/ui/shared/popover/popoverIndex';
import { setFtdReminderLastShown } from './ftdReminder';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export default defineComponent({
    name: 'FtdReminderPopover',
    props: {
        isMobile: {
            type: Boolean,
            required: true,
        },
    },
    setup(_props) {
        const popoverStore = useVuexStore<PopoversStore>('ui/popover');
        const isVisibleByStore = computed(() => popoverStore.getter('isFtdReminderVisible').value);
        const { route: currentRoute } = useVueRouter();
        const isDepositPage = computed(() => currentRoute.value.name === RouteName.Account.Deposit);
        const isFtdReminderVisible = computed(() => isVisibleByStore.value && !isDepositPage.value);

        function closePopover() {
            popoverStore.action('hideFtdReminder')();
        }

        function closeWithAnalytics() {
            AnalyticsSDK.getInstance().log('Deposit_Reminder_Closed');
            closePopover();
        }

        const popoverRef = ref<HTMLElement | null>(null);
        const { isClickOutside } = useClickOutside(popoverRef);
        watch(isClickOutside, (newValue) => {
            if (newValue) {
                closePopover();
            }
        });

        const { loginBeforeNavigate } = useLoginBeforeNavigate();
        const navigateToDeposit = (route: Route) => {
            AnalyticsSDK.getInstance().log('Deposit_Reminder_Accept');
            closePopover();
            loginBeforeNavigate(route);
        };

        const onKeyup = (event: KeyboardEvent) => {
            const key = getKey(event);

            if (key === Keys.ESC) {
                closeWithAnalytics();
            }
        };

        watch(isFtdReminderVisible, (newValue) => {
            if (newValue) {
                AnalyticsSDK.getInstance().log('Deposit_Reminder_Shown');
                setFtdReminderLastShown();
            }
        });

        onMounted(() => {
            document.addEventListener('keyup', onKeyup);
        });

        onUnmounted(() => document.removeEventListener('keyup', onKeyup));

        return {
            isFtdReminderVisible,
            popoverRef,
            RouteName,
            closeWithAnalytics,
            loginBeforeNavigate,
            navigateToDeposit,
        };
    },
    components: {
        SdsButton,
        SdsButtonIcon,
        SdsIllustration,
    },
});
